<script>
import professionalMixin from "@/mixins/accountable/professionalMixin";
import orderMixin from "@/mixins/orderMixin";

import Modal from "@/components/_Shared/Modal/Index";
import Title from "@/components/_Shared/Title";
import Tip from "@/components/_base/Tip";
import Cancellation from "@/components/Order/Components/Actions/Cancellation/Index";

export default {
  mixins: [professionalMixin, orderMixin],

  components: {
    Modal,
    Title,
    Tip,
    Cancellation
  },

  props: {
    orders: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      rescheduling: false,
      reschedulingOrder: null
    };
  },

  methods: {
    reschedule(order) {
      this.rescheduling = true;
      this.reschedulingOrder = order;
    }
  }
};
</script>

<template>
  <Modal>
    <template slot="header">
      <Title title="Limpezas não realizadas" />
    </template>

    <template slot="body">
      <div class="orders">
        <div class="order" v-for="order in orders" :key="order.id" @click="reschedule(order)">
          <div class="order-content">
            <div class="left">
              <img :src="order.professional | profilePicture" />

              <div class="content">
                <span class="name">
                  {{ order.professional | firstName }}
                </span>

                <span class="order-count">
                  <b>{{ order.professional | orderCount | minOrderCount }} limpezas</b> <span> realizadas</span>
                </span>
              </div>
            </div>

            <div class="right">
              <div class="duration">
                <img src="/static/clock-outlined.svg" />
                <span>{{ order | getOrderDuration }}</span>
              </div>

              <div class="location">
                <img src="/static/pin.svg" />
                <span>{{ order | getOrderAddressName }}</span>
              </div>
            </div>
          </div>

          <div class="order-footer">
            <span>reagendar</span>

            <img src="/static/basic/arrow-next.svg" />
          </div>
        </div>

        <Cancellation
          v-if="rescheduling"
          :order="reschedulingOrder"
          type="rescheduling"
          @close="rescheduling = false"
        />
      </div>
    </template>

    <template slot="footer">
      <Tip>Selecione a limpeza que gostaria de reagendar</Tip>

      <button
        class="btn bg-purple"
        @click="$emit('close')"
      >
        <span>Voltar</span>
      </button>
    </template>
  </Modal>
</template>

<style scoped>
.orders > *:not(:last-child) {
  margin-bottom: 8px;
}

.order {
  width: calc(100% - 24px - 2px);
  padding: 12px;
  position: relative;
  background-color: #fff;
  border: solid 1px #e2e2e2;
  border-radius: 2px;
  cursor: pointer;
  user-select: none;
}

.order::before {
  width: calc(100% + 2px);
  height: 6px;
  position: absolute;
  top: -1px;
  left: -1px;
  content: "";
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  background-color: #af006b;
}

.order-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.left {
  width: 70%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.order-content > .left > img {
  width: 36px;
  height: 36px;
  margin-right: 8px;
  border-radius: 50%;
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.content > .name {
  font-size: 16px;
  font-weight: 400;
}

.content > .order-count {
  font-size: 12px;
}

.content > .order-count > b {
  font-weight: 400;
  color: #603285;
}

.content > .order-count > span {
  display: none;
}

.right {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
}

.right img {
  width: 14px;
  margin-right: 4px;
}

.date,
.duration,
.location {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 13px;
}

/* footer */
.order-footer {
  margin-top: 8px;
  padding: 16px 0 4px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-top: solid 1px #e2e2e2;
}

.order-footer > span {
  font-size: 14px;
  font-weight: 400;
  color: #603285;
}

.order-footer > img {
  width: 14px;
  height: 14px;
}

@media (min-width: 360px) {
  .content > .order-count > span {
    display: inline;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/components/Payables/NotProvidedPayablesList.vue